import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as actions from './banners.actions';
import * as BannersSelectors from './banners.selectors';
import { Observable } from 'rxjs';
import { BannerMessage } from '../banners.model';

@Injectable()
export class BannersFacade {
    banners$: Observable<BannerMessage[]> = this.store.pipe(select(BannersSelectors.banners));

    constructor(private store: Store) {}

    getBanners(): void {
        this.store.dispatch(actions.getBanners());
    }
}
